var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSantaHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 57 42.852",
    viewBox: "0 0 57 42.852",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.935,
    cy: 23.306,
    r: 5.935
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.601 27.093h33.566s-.614-14.941-7.675-20.876-15.248-7.573-24.151-5.117-13.349 10.809-14.122 12.484c-.614 1.331-.819 2.149-.819 2.149s1.334-.438 2.968-.205c1.433.205 2.558 1.126 2.558 1.126s4.093-3.786 6.345-.819 1.33 11.258 1.33 11.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.192 28.832h33.975s5.833.716 5.833 7.368-5.833 6.652-5.833 6.652h-33.975s-6.242-.409-6.242-7.061 6.242-6.959 6.242-6.959z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaHat);
export default __webpack_public_path__ + "static/media/santa-hat.a70080332329480162bf0be51e041511.svg";
export { ForwardRef as ReactComponent };